export default class Post {
  public id!: string;
  public name!: string;
  public verticalVideoURL!: string;
  public horizontalVideoURL!: string;
  public youtubeURL!: string;
  public tools!: string[];
  public collaboration!: string[];
  public links!: string[];
  public imageURL!: string;
  public date!: string;
  public description!: string;
  public glsl!: string[];
  public workInProgress!: boolean;
}